export const binaryToDecimal = (binaryString?: string) =>
  binaryString ? parseInt(String(binaryString).replace(/[^01]/gi, ''), 2) : '';